import { render } from "./createUser.vue?vue&type=template&id=766035a2"
import script from "./createUser.vue?vue&type=script&lang=js"
export * from "./createUser.vue?vue&type=script&lang=js"

import "./createUser.vue?vue&type=style&index=0&id=766035a2&lang=css"

import exportComponent from "/Users/1M/Projects/SLE/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__